/* eslint-disable no-case-declarations */
import { Discount } from 'app/types/admin/customerUser';
import { ImmutableList, ImmutableMap } from 'app/types/admin';
import { LaaSType } from 'app/constants/Products';

class LabsPriceCalculator {
  discounts: ImmutableList<Discount> | Discount[];
  sub_product: string;

  constructor(discounts: ImmutableList<Discount> | Discount[], sub_product: string) {
    this.discounts = discounts;
    this.sub_product = sub_product;
  }

  atHomeLabPrice = () => (this.sub_product == LaaSType.BaseTestKit ? 99_99 : 149_99);

  labCost = () => this.atHomeLabPrice();

  creditUsage = () => 0;

  totalDueToday() {
    const cost = this.labCost() - this.totalDiscountsValue();
    return Math.max(0, cost);
  }

  totalDiscountsValue() {
    let total = 0;

    this.discounts.map((discount) => {
      total += this.discountPrice(discount)!;
    });

    return total;
  }

  discountPrice(discount: ImmutableMap<Discount>) {
    const isLab = discount?.get('product_name')?.slice(-4) === '_lab';

    if (!isLab) {
      return 0;
    }

    const amountUsed = discount.get('uses').reduce((sum, use) => sum + use.get('amount_used'), 0);
    const coupon = discount?.get('coupon');
    const couponParams = coupon?.get('params');
    const discountType = coupon?.get('discount_type');

    const basePrice = this.labCost();

    switch (discountType) {
      case 'subscription_payments_off_forever':
        const discountForeverPercentage = couponParams?.get('percentage_off');

        return discountForeverPercentage * 0.01 * basePrice;
      case 'subscription_payments_off':
        const discountPercentage = couponParams?.get('percentage_off');

        const totalDiscountedPrice = basePrice * discountPercentage * 0.01;

        return totalDiscountedPrice > basePrice ? basePrice : totalDiscountedPrice;
      case 'fixed_amount_off':
        const discountAmount = couponParams?.get('fixed_amount_off') - amountUsed;

        return discountAmount > basePrice ? basePrice : discountAmount;
      default:
        throw new Error('Invalid coupon type');
    }
  }
}

export default LabsPriceCalculator;
